/**
 * An event doesn't store a period: it belongs to the period that contains its start date.
 */
export class EventPeriodHelper {
    static isInPeriod(event, period) {
        return period.includesDate(event.startDate);
    }
    static isInAnyPeriod(event, periods) {
        return periods.some(period => this.isInPeriod(event, period));
    }
    /**
     * Matches the events of a period, for endpoints that filter on events.
     */
    static getPeriodFilter(period) {
        return {
            startDate: {
                $gte: period.startDate,
                $lte: period.endDate,
            },
        };
    }
}
//# sourceMappingURL=EventPeriodHelper.js.map